module.exports = __webpack_public_path__ + "static/img/D.377eb28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/D.png
// module id = URZ5
// module chunks = 0